
import { computed, defineComponent, ref } from 'vue'
import storiesList from '../../store/stores/stories/storiesList'
import StoriesModal from './StoriesModal/StoriesModal.vue'
import { openInNewTab } from '../../utils'
import useRouter from '@/hooks/useRouter'
import get from 'lodash/get'

export default defineComponent({
    components: { StoriesModal },
    props: {
        id: { type: String, required: true },
        skeleton: { type: Boolean },
    },
    setup(props, { emit }) {
        const router = useRouter()
        const stories = computed(() => get(storiesList, props.id))
        const modalIsOpen = ref(false)

        const shellStyles = computed(() => {
            if (props.skeleton) {
                return {
                    background: '#E8EAF0',
                    boxShadow: 'none',
                }
            }
            const { gradient1, gradient2 } = stories.value.colors
            return {
                '--g1': gradient1,
                '--g2': gradient2,
            }
        })

        const openModal = () => {
            modalIsOpen.value = true
        }

        const onClick = () => {
            if (props.id === 'marketplace') {
                router.router.push(`${router.route.value.fullPath}/marketplace`)
                return
            } else if (props.id === 'sightseeing-tour') {
                emit('show-video', true)
                return
            } else if (stories.value.hrefTo) {
                return openInNewTab(stories.value.hrefTo)
            }
            openModal()
        }

        return { onClick, stories, shellStyles, modalIsOpen }
    },
})
